import React from 'react';
import { Col, Container } from 'react-bootstrap';
import { TopMenu } from '../../shared';

function TermsAndConditions() {

    return (
        <>
            <TopMenu />

            <Col lg={12} className='inner-bg'>
                <Container className='middle-content'>
                    <div className="page-heading">
                        <img src='https://pmfby.amnex.co.in/pmfby/lms/lms-inner-banner.jpg' alt='Inner Banner - LMS' className='img-fluid pb-4' />
                        <h4 className="fw-bold mb-2">Terms and Conditions</h4>
                        <ul className="my-topbreadcrum">
                            <li>
                                <a
                                    href="/lms"

                                >Home</a>
                            </li>
                            &nbsp; / &nbsp;
                            <li>Terms & Conditions</li>
                        </ul>
                    </div>
                    <div>
                        <p>This website belongs to Department of Agriculture and Farmers Welfare, Ministry of Agriculture and Farmers Welfare, Government of India.</p>
                        <p>These terms and conditions shall be governed by and construed in accordance with the Indian Laws. Any dispute arising under these terms and conditions shall be subject to the jurisdiction of the courts of India.</p>
                        <p>The information posted on this website could include hypertext links or pointers to information created and maintained by non-Government/private organisations. Department of Agriculture and Farmers Welfare is providing these links and pointers solely for your information and convenience. When you select a link to an outside website, you are leaving the 'Guidelines for Indian Government Websites' and are subject to the privacy and security policies of the owners/sponsors of the outside website.</p>

                        <p>We may modify these terms or any additional terms that apply to a Service to, for example, reflect changes to the law or changes to our Services. You should look at the terms regularly. We’ll post notice of modifications to these terms on this page. We’ll post notice of modified additional terms in the applicable Service. However, changes addressing new functions for a Service or changes made for legal reasons will be effective immediately. If you do not agree to the modified terms for a Service, you should discontinue your use of that Service.</p>
                    </div>
                </Container>
            </Col>
        </>
    );
}

export default TermsAndConditions;